import { toSlug } from '@crossnokaye/ux-common';
import {
  MobileMenuLabel,
  MobileMenuStackScreenContent,
  MobileMenuSubTrigger,
  useSimpleStackNavigator,
} from '@crossnokaye/ux-common/ckds';
import { MobileMenuSeparator } from '@crossnokaye/ux-common/ckds';

import { EquipmentBrowserSection } from '@repo/sdk/models/components';

interface JumpToSectionScreenProps {
  sections: EquipmentBrowserSection[];
}

export const JumpToSectionScreen = ({ sections }: JumpToSectionScreenProps) => {
  const { pushScreen } = useSimpleStackNavigator();
  const openEquipmentScreen = (section: EquipmentBrowserSection) => {
    pushScreen(`jump-to-equipment-screen-${toSlug(section.name)}`); // TODO: change to id when we have a unique id for each section
  };
  return (
    <MobileMenuStackScreenContent>
      <MobileMenuLabel>Equipment Categories</MobileMenuLabel>
      <MobileMenuSeparator />

      {sections.map((section) => (
        <MobileMenuSubTrigger onClick={() => openEquipmentScreen(section)} className="capitalize">
          {section.name}
        </MobileMenuSubTrigger>
      ))}
    </MobileMenuStackScreenContent>
  );
};
